import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  PersistConfig,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import the slices
import authReducer from "@store/slices/authSlice";
import notificationReducer from "@store/slices/notificationSlice";
import { notificationListener } from "@store/slices/notification.listener";

// Persist configurations
const authPersistConfig: PersistConfig<any> = {
  key: "auth",
  storage,
  whitelist: ["user", "token", "isAuthenticated"],
};

const notificationPersistConfig: PersistConfig<any> = {
  key: "notification",
  storage,
  whitelist: ["headerNotifications", "allNotifications"],
};

// Create persisted reducers
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedNotificationReducer = persistReducer(notificationPersistConfig, notificationReducer);

import curatorReducer from "@store/slices/curatorSlice";
import groupPackageReducer from "@store/slices/groupPackageSlice";
import countryReducer from "@store/slices/countrySlice";
import categoryReducer from "@store/slices/categorySlice";
import callReducer from "@features/call/store/callSlice";

// Create root reducer
const rootReducer = combineReducers({
  auth: persistedAuthReducer,
  notification: persistedNotificationReducer,
  curator: curatorReducer,
  groupPackage: groupPackageReducer,
  country: countryReducer,
  category: categoryReducer,
  call: callReducer,
});

// Configure store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).prepend(notificationListener.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

// Create persistor
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
